import useSWR from 'swr';

import { getCaseComments, type CaseComment } from '@/api/urgent-cases';
import { ENDPOINTS } from '@/api/endpoints';
import { StandardResponse } from '@/api/standard-response';

type Key = [string, string];

export function useGetCaseComments(caseId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<
    StandardResponse<CaseComment[]>,
    Error,
    Key | null
  >(caseId ? [ENDPOINTS.CASE_COMMENTS, caseId] : null, ([, id]: Key) => getCaseComments(id), {
    errorRetryCount: 1,
    revalidateOnFocus: false,
  });

  return {
    comments: data?.data ?? [],
    loading: isLoading,
    error,
    mutate,
  };
}
